import { useState, useEffect } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { CheckCircle, XCircle, Loader, ArrowLeft } from 'lucide-react';
import { useBranding } from '../contexts/BrandingContext';

const VerifyEmail = () => {
  const { branding } = useBranding();
  const [searchParams] = useSearchParams();
  const [status, setStatus] = useState('verifying'); // verifying, success, error
  const [message, setMessage] = useState('');
  const token = searchParams.get('token');

  useEffect(() => {
    if (!token) {
      setStatus('error');
      setMessage('Invalid verification link');
      return;
    }

    const verifyEmail = async () => {
      try {
        const response = await fetch(`/api/verify-email?token=${token}`);
        const data = await response.json();

        if (response.ok && data.success) {
          setStatus('success');
          setMessage(data.message);
        } else {
          setStatus('error');
          setMessage(data.error || 'Verification failed');
        }
      } catch (err) {
        setStatus('error');
        setMessage('Verification failed. Please try again.');
      }
    };

    verifyEmail();
  }, [token]);

  return (
    <div className="login-page">
      <div className="login-container">
        <div className="login-header">
          {status === 'verifying' && (
            <>
              <Loader size={64} className="spin" style={{ color: '#3b82f6' }} />
              <h1>Verifying Email...</h1>
              <p>Please wait while we verify your email address.</p>
            </>
          )}

          {status === 'success' && (
            <>
              <CheckCircle size={64} style={{ color: '#10b981' }} />
              <h1>Email Verified!</h1>
              <p>{message}</p>
            </>
          )}

          {status === 'error' && (
            <>
              <XCircle size={64} style={{ color: '#ef4444' }} />
              <h1>Verification Failed</h1>
              <p style={{ color: '#ef4444' }}>{message}</p>
            </>
          )}
        </div>

        <div style={{ textAlign: 'center', marginTop: '24px' }}>
          {status === 'success' && (
            <Link to="/login" className="btn btn-primary" style={{ display: 'inline-flex', alignItems: 'center', gap: '8px' }}>
              Continue to Login
            </Link>
          )}

          {status === 'error' && (
            <Link to="/register" className="btn btn-secondary" style={{ display: 'inline-flex', alignItems: 'center', gap: '8px' }}>
              <ArrowLeft size={18} />
              Try Again
            </Link>
          )}
        </div>

        {(!branding.isWhiteLabeled || branding.poweredByVisible) && (
          <div className={branding.isWhiteLabeled ? 'powered-by-footer' : 'login-footer'}>
            {branding.isWhiteLabeled ? 'Powered by Serverli' : <p>Powered by Serverli</p>}
          </div>
        )}
      </div>
    </div>
  );
};

export default VerifyEmail;
